import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IModalTmpGifController} from "views/components/modals/modal_tmp_gif/modal_tmp_gif.controller";
import styled from "@emotion/styled";
import {IconButton, Modal, Stack} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import tmpImage from "assets/img/tmp/Viewing-stats-6fps-x2canvas.gif";
import tmpImage2 from "assets/img/tmp/Viewing-stats-6fps-x2canvas@30lossy.gif";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: var(--modalBackground);
	padding: 16px 20px 32px;
	border-radius: 4px;
	text-align: center;
	color: #ffffff;
	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}
`;

const CloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	button {
		padding: 0;

		svg {
			width: 32px;
			height: 32px;
			color: #fff;
		}
	}
`;

const Gifs = styled.img`
	max-width: 300px;
	margin: 0 auto;
	display: block;
`;
export const ModalTmpGif: React.FC = observer(() => {
	const {isOpen, close} = useViewController<IModalTmpGifController>(
		Bindings.ModalTmpGifController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={close}>
						<CloseIcon color={"inherit"} />
					</IconButton>
				</CloseBlock>
				<Stack>
					<p>Viewing-stats-6fps-x2canvas</p>
					<Gifs src={tmpImage} alt="TMP" />
				</Stack>
				<Stack>
					<p>Viewing-stats-6fps-x2canvas@30lossy.gif</p>
					<Gifs src={tmpImage2} alt="TMP" />
				</Stack>
			</ModalContent>
		</Modal>
	);
});
